<template>
  <v-dropdown
    :offset="4"
    :shown="open"
    :triggers="[]"
    :auto-hide="autoHide"
    :class="{
      'v-popper--full-width': fullWidth,
    }"
    :placement="placement"
    :aria-label="ariaId"
    @auto-hide="$emit('autoHide')"
  >
    <!-- This will be the popover target (for the events and position) -->
    <slot name="default" />

    <!-- This will be the content of the popover -->
    <template #popper>
      <slot name="popover" />
    </template>
  </v-dropdown>
</template>

<script lang="ts">
import { Dropdown as VDropdown } from 'floating-vue';
import 'floating-vue/dist/style.css';

export default defineComponent({
  components: { VDropdown },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    autoHide: {
      type: Boolean,
      default: true,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: 'bottom',
    },
  },
  emits: ['autoHide'],
  setup() {
    return {
      // This prevents hydration warnings. Will hopefully be fixed using Nuxt's `useId()`
      // Issue: https://github.com/Akryum/floating-vue/issues/1006
      ariaId: 'fn-popover-id',
    };
  },
});
</script>

<style lang="scss">
// Popper DOM node get detached from this components DOM node, so we can no scope these styles
// @see https://floating-vue.starpad.dev/guide/css
// @see https://floating-vue.starpad.dev/guide/themes
// @see https://floating-vue.starpad.dev/theme-editor
.v-popper--theme-dropdown {
  display: inline-block;

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition:
      opacity 0.15s,
      visibility 0.15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }

  &.v-popper {
    &--full-width {
      width: 100%;
    }

    &__inner {
      border-radius: 6px;
      box-shadow: 0 2px 20px 5px rgba(black, 0.1);
      background: $color-general-background-neutral-default;
      color: palette(black);
      border: none;
      overflow: hidden;
    }

    // Hide second arrow element acting as hard shadow
    &__arrow-outer {
      display: none;
    }
  }
}
</style>
